import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function Hero() {
  const [isFlipped, setIsFlipped] = useState(false);
  return <section id="home" className="min-h-screen flex items-center pt-20 px-6 relative overflow-hidden" data-id="element-54">
      <div className="max-w-7xl mx-auto w-full grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-55">
        {/* Left Content */}
        <motion.div initial={{
        opacity: 0,
        x: -50
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="space-y-8" data-id="element-56">
          {/* Removed Portfolio 2024 Badge */}

          <h1 className="text-4xl md:text-4xl font-moon-dance text-zen-text leading-tight" data-id="element-57">
            Hey, I'm <span className="text-zen-accent" data-id="element-58">Anjali</span> - an automation tester by profession and an empathetic soul by nature. <br data-id="element-59" />
            
          </h1>

          <p className="p.text-lg.md:text-xl.text-zen-text/70.max-w-2xl.leading-relaxed.font-light" data-id="element-60">
            I debug systems for a living, but most days, I feel like I'm debugging life - one experience at a time. If you're navigating your career, struggling with self-doubt, exploring life, or simply trying to make each day hurt a little less - you're exactly where you need to be.
          </p>
          <p className="p.text-lg.md:text-xl.text-zen-text/70.max-w-2xl.leading-relaxed.font-light" data-id="element-61">
            Let's talk. Let's learn. Let's make life a little less painful, together.
          </p>

          <motion.button whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} className="group flex items-center gap-3 px-8 py-4 bg-zen-text text-white rounded-full hover:bg-zen-accent transition-colors duration-300" data-id="element-62">
            <span data-id="element-63">Begin Exploring</span>
            <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-64" />
          </motion.button>
        </motion.div>

        {/* Right Image - Flip Card */}
        <div className="relative h-[500px] w-full flex justify-center items-center perspective-1000" data-id="element-65">
          <motion.div animate={{
          rotateY: isFlipped ? 180 : 0
        }} transition={{
          duration: 0.6,
          type: 'spring',
          stiffness: 260,
          damping: 20
        }} className="relative w-[400px] h-[400px] transform-style-3d cursor-pointer" onClick={() => setIsFlipped(!isFlipped)} data-id="element-66">
            {/* Front - Circular Image */}
            <div className="absolute inset-0 backface-hidden rounded-full overflow-hidden shadow-2xl border-4 border-white/50" data-id="element-67">
              <img src="https://cdn.magicpatterns.com/uploads/bGhbfN5zh897Zj8qhgA3Ct/IMG_8801.jpg" alt="Anjali Portrait" className="w-full h-full object-cover" data-id="element-68" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent" data-id="element-69" />
              <div className="absolute bottom-8 left-0 right-0 text-center text-white" data-id="element-70">
                <p className="font-moon-dance text-2xl opacity-80" data-id="element-71">
                  Click to flip
                </p>
              </div>
            </div>

            {/* Back - Circular Content */}
            <div className="absolute inset-0 backface-hidden rotate-y-180 bg-zen-accent rounded-full p-8 flex flex-col justify-center items-center text-center shadow-2xl border-4 border-white/20 overflow-hidden" data-id="element-72">
              <div className="overflow-y-auto max-h-full scrollbar-hide" data-id="element-73">
                <p className="text-white/90 font-sans text-sm leading-relaxed" data-id="element-74">
                  Technology excites me, especially the thrill of solving a
                  problem that looks impossible at first glance. But beyond code
                  and test cases, I'm someone who finds joy in small things —
                  dancing to music that lifts my heart, talking to little paws
                  who understand without words.
                </p>
                <p className="text-white/90 font-sans text-sm leading-relaxed mt-3 pt-3 border-t border-white/20" data-id="element-75">
                  People often say life works in strange ways. I say — God works
                  in mysterious ways. Every twist, every pause, every setback…
                  has shaped the person I am today.
                </p>
              </div>
            </div>
          </motion.div>

          {/* Floating Elements */}
          <motion.div animate={{
          y: [0, -20, 0]
        }} transition={{
          duration: 4,
          repeat: Infinity,
          ease: 'easeInOut'
        }} className="absolute top-0 right-10 w-24 h-24 bg-zen-accent/10 rounded-full blur-xl" data-id="element-76" />
          <motion.div animate={{
          y: [0, 20, 0]
        }} transition={{
          duration: 5,
          repeat: Infinity,
          ease: 'easeInOut',
          delay: 1
        }} className="absolute bottom-0 left-10 w-32 h-32 bg-zen-text/5 rounded-full blur-xl" data-id="element-77" />
        </div>
      </div>
    </section>;
}